import { Link } from 'react-router-dom';
import { Empty, Space, Typography } from 'antd';

function EmptyComponent({ hasQuery = false, isPriorityTab = false }) {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <Space direction="vertical" size="small">
          <p>
            {hasQuery
              ? "Your search didn't return any matches."
              : isPriorityTab
              ? 'The Manual/API Queue is currently empty.'
              : 'The Automated Queue is currently empty.'}
          </p>
          <Typography.Paragraph>
            <p>
              <Typography.Text>{'You can '}</Typography.Text>
              <Link className="text-info mx-2" to="/recache-stats">
                view all recent Caching Requests
              </Link>
              {isPriorityTab && (
                <>
                  <Typography.Text>
                    {` `}
                    or add URLs to the queue for recaching
                  </Typography.Text>
                  <Link className="text-info mx-2" to="/cache">
                    manually
                  </Link>
                  <Typography.Text> or via</Typography.Text>
                  <a
                    className="text-info ml-2"
                    target="_blank"
                    href="https://docs.prerender.io/docs/en/6-api"
                    rel="noreferrer"
                  >
                    API Call
                  </a>
                  .
                </>
              )}
            </p>
          </Typography.Paragraph>
        </Space>
      }
    />
  );
}

export default EmptyComponent;
